import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { KeycloakService } from '../../services/keycloak.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { SafePipe } from '../../pipes/safe.pipe';

@Component({
  standalone: true,
  selector: 'orders-cmp',
  templateUrl: 'order.component.html',
  styleUrls: ['order.component.scss'],
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet, TranslatePipe, SafePipe],
})
export class OrderComponent {
  isAdmin: boolean;
  isSector: boolean;

  constructor() {
    this.isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
    this.isSector = KeycloakService.auth.authz.hasRealmRole('ROLE_SECTOR');
  }
}
